/* global $ */

const $autofox = $('.autofox');
const $autofoxLocationFilter = $('.js-autofox-location-filter');
const $autofoxCourseFilter = $('.js-autofox-course-filter');

const autofox = {
  initialize() {
    if ($autofox.length) {
      this.createListeners();
      this.handleAutofoxRequests(window.autofoxRequests);
    }
  },

  createListeners() {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          if (!addedNode) return;

          if (addedNode.tagName === 'TR' && addedNode.innerHTML.includes('Geen plaatsen beschikbaar')) {
            addedNode.classList.add('no-places');
          }

          let buttons = addedNode.querySelectorAll('button.af-btn-disabled');
          buttons = Array.prototype.slice.call(buttons);

          buttons.forEach((button) => {
            if (button.textContent.trim().toLowerCase() !== 'neem contact op') return;

            button.removeAttribute('data-book-item');
            button.removeAttribute('disabled');
          });
        });
      });
    });

    observer.observe($autofox[0], { subtree: true, childList: true });

    $autofox.on('click', 'button.af-btn-disabled', (e) => {
      e.preventDefault();

      window.location.href = '/contact';
    });

    document.addEventListener('autofox-request', () => {
      this.handleAutofoxRequests(window.autofoxRequests);
    });
  },

  handleAutofoxRequests(autofoxRequests) {
    autofoxRequests.forEach((autofoxRequest) => {
      try {
        const { responseText } = autofoxRequest;

        if ($autofoxLocationFilter.length) {
          const response = JSON.parse(responseText);

          const {
            theoryCourses,
            customLessons,
            responseCourses,
            practicalLessons,
          } = response;

          const locations = [];
          const courses = [];

          if (typeof theoryCourses !== 'undefined' && Array.isArray(theoryCourses)) {
            theoryCourses.forEach((course) => {
              const { location } = course;

              if (typeof location !== 'undefined' && locations.indexOf(location) < 0) {
                locations.push(location);
              }

              if (courses.indexOf(course.description) < 0) {
                courses.push(course.description);
              }
            });
          }

          if (typeof customLessons !== 'undefined' && Array.isArray(customLessons)) {
            customLessons.forEach((course) => {
              const { location } = course;

              if (typeof location !== 'undefined' && locations.indexOf(location.description) < 0) {
                locations.push(location.description);
              }

              if (courses.indexOf(course.description) < 0) {
                courses.push(course.description);
              }
            });
          }

          if (typeof responseCourses !== 'undefined' && Array.isArray(responseCourses)) {
            responseCourses.forEach((course) => {
              const { location } = course;

              if (typeof location !== 'undefined' && locations.indexOf(location.description) < 0) {
                locations.push(location.description);
              }

              if (courses.indexOf(course.description) < 0) {
                courses.push(course.description);
              }
            });
          }

          if (typeof practicalLessons !== 'undefined' && Array.isArray(practicalLessons)) {
            practicalLessons.forEach((course) => {
              const { location } = course;

              if (typeof location !== 'undefined' && locations.indexOf(location.description) < 0) {
                locations.push(location.description);
              }

              if (courses.indexOf(course.description) < 0) {
                courses.push(course.description);
              }
            });
          }

          if ($autofoxLocationFilter.length) {
            locations.sort().forEach((location) => {
              $autofoxLocationFilter.append(`<option value="${location}">${location}</option>`);
            });
          }

          if ($autofoxCourseFilter.length) {
            courses.sort().forEach((course) => {
              $autofoxCourseFilter.append(`<option value="${course}">${course}</option>`);
            });
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    });
  },
};

export default autofox;
